import(/* webpackMode: "eager", webpackExports: ["ClientPage"] */ "/vercel/path0/src/app/(pages)/(case-studies)/airtime/client.tsx");
